import React, { useReducer, useEffect, useMemo } from 'react';

import { useConfig } from './ConfigContext'

import { useSchedules } from '../queries/schedules';

import SeasonFilter from './Filters/SeasonFilter';
import DivisionFilter from './Filters/DivisionFilter';
import GenderFilter from './Filters/GenderFilter';
import ScheduleFilter from './Filters/ScheduleFilter';
import GroupFilter from './Filters/GroupFilter';
import reducer from './Filters/reducer';
import { useGroups } from '../queries/groups';
import { AdsComponent } from './Ads.component';

export default ({ officeId, office, initialValues, children, ...props }) => {
  const { seasonId } = useConfig();

  const defaultFilters = useMemo(() => ({ ...initialValues, officeId, seasonId }), [ initialValues, officeId, seasonId ])
  const [ filters, dispatch ] = useReducer(reducer, defaultFilters);

  const { data: schedules, isLoading: isSchedulesLoading } = useSchedules({
    officeId,
    seasonId: filters.seasonId,
    divisionId: filters.divisionId,
    gender: filters.gender,
  }, {
    enabled: !!filters.seasonId && !!officeId,
  })
  const schedule = filters.scheduleId && schedules?.find(schedule => schedule.id == filters.scheduleId)

  const { data: groups, isLoading: isGroupsLoading } = useGroups({ ...schedule, officeId })

  useEffect(() => {
    dispatch({ action: 'reset', state: defaultFilters })
  }, [ officeId, defaultFilters ])

  useEffect(() => {
    // automatically select the only option or league if applicable
    if (filters.scheduleId || !schedules?.length) return;
    if (schedules.length === 1) {
      dispatch({ action: 'select-option', name: 'scheduleId', option: schedules[0].id })
      return;
    }
    const regular = schedules.filter(schedule => schedule.type === 'League')
    if (regular.length === 1) {
      dispatch({ action: 'select-option', name: 'scheduleId', option: regular[0].id })
    }
  }, [ schedules, filters.scheduleId ])

  const updateFilter = (option, action) => {
    let value;
    if (action.name === 'scheduleId') {
      if (!schedules?.length) return;
      value = schedules.find(schedule => schedule.id == option)
    } else if (action.name === 'groupId') {
      if (!groups?.length) return;
      value = groups.find(group => group.id == option)
    } else {
      value = option;
    }
    dispatch({ ...action, option, value })
  }

  return <>
    <div className="main-filters my-3">
      <SeasonFilter filters={filters} onSelect={updateFilter} />
      <DivisionFilter filters={filters} onSelect={updateFilter} />
      <GenderFilter filters={filters} onSelect={updateFilter} />
      <ScheduleFilter schedules={schedules} filters={filters} onSelect={updateFilter} isLoading={isSchedulesLoading} />
      <GroupFilter groups={groups} filters={filters} onSelect={updateFilter} isLoading={isGroupsLoading} />
    </div>
    <AdsComponent />
    { React.cloneElement(children, {
      officeId,
      filters,
      data: { office, schedules, groups },
      ...props,
    })}
  </>
}
